<template>
  <baseLogPage :uploadType="66" tabName="销售线索导入历史" downloadFileName="销售线索导入失败"></baseLogPage>
</template>
<script>
import baseLogPage from '@/pages/others/baseLogPage'

export default {
  components: { baseLogPage },
}
</script>
